import type { KeyboardEvent as ReactKeyboardEvent } from 'react'

/**
 * Enter で送信・確定する keydown か。 IME の変換を確定する Enter では false を返す。
 * 日本語入力では、 変換を確定するための Enter で送信・確定まで走ると、 確定前の文字列で
 * 送ってしまう。
 *
 * 変換確定の判定は 2 つの印のどちらかで行う。
 *
 * - `isComposing`: 変換中に押されたキー (React の合成 event では `nativeEvent` の側にある)
 * - `keyCode === 229`: Safari は確定の Enter を compositionend の後に送り、 `isComposing` が
 *   false になる。 この Enter は keyCode が 229 (IME が処理したキー) になるので、 それで見分ける
 *
 * Enter の判定を各ハンドラで直書きすると変換確定の除外を書き忘れるので、 `'Enter'` という
 * 文字列と keyCode 13 の比較は lint (`@ebalance/eslint-config` の restricted-syntax) が止め、
 * この file だけを除外している。
 * text 入力でない要素 (role="button" の行やカード) では変換が起きないので、 結果は
 * `e.key === 'Enter'` と同じになる。
 */
export const isEnterKey = (e: KeyboardEvent | ReactKeyboardEvent): boolean => {
  if (e.key !== 'Enter') {
    return false
  }
  const isComposing =
    'nativeEvent' in e ? e.nativeEvent.isComposing : e.isComposing
  return !isComposing && e.keyCode !== 229
}
